import React from 'react';
import PropTypes from 'prop-types';
import cx from '@/utils/cx';
import useStyle from './style';

const CellItem = ({
  children,
  grow,
  className,
  overflow,
  ...rest
}) => {
  const classes = useStyle({ grow , overflow });

  return (
    <div
      className={cx(
        classes.cellItem,
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
};

CellItem.propTypes = {
  /* grow this element to fill empty parts of parent */
  grow: PropTypes.bool,
  overflow: PropTypes.string,
};

CellItem.defaultProps = {
  grow: false,
  overflow: 'hidden',
};

export default CellItem;
